import dayjs from 'dayjs';
import { Transporter } from './transporter.model';

export interface IEdiHistory {
  id?: number;
  filePath?: string | null;
  date?: dayjs.Dayjs | null;
  author?: string | null;
  transportOrderId?: number | null;
  transporter?: Transporter;
}

export class EdiHistory implements IEdiHistory {
  constructor(
    public id?: number,
    public filePath?: string | null,
    public date?: dayjs.Dayjs | null,
    public author?: string | null,
    public transportOrderId?: number | null,
    public transporter?: Transporter
  ) {}
}

export function getEdiHistoryIdentifier(ediHistory: IEdiHistory): number | undefined {
  return ediHistory.id;
}
